import { render, staticRenderFns } from "./bsp-noData.vue?vue&type=template&id=f7194a3a&scoped=true&"
import script from "./bsp-noData.vue?vue&type=script&lang=js&"
export * from "./bsp-noData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7194a3a",
  null
  
)

export default component.exports